<template>
  <div class="input-group">
    <div @click="remove()" class="input-group-prepend">
      <span class="input-group-text px-1">
        <i class="material-icons">remove</i>
      </span>
    </div>
    <input
      :value="value"
      @input="input($event.target.value)"
      type="text"
      class="form-control text-center"
      :disabled="!limit || disabled"
      required
    >
    <div @click="add()" class="input-group-append">
      <span class="input-group-text px-1">
        <i class="material-icons">add</i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'limit', 'disabled'],
  methods: {
    input(e) {
      this.$emit('input', parseInt(e, 0) || 0);
    },
    remove() {
      if (this.value <= 1) return;
      this.$emit('input', this.value - 1);
    },
    add() {
      if (this.value >= this.limit) return;
      this.$emit('input', this.value + 1);
    },
  },
};
</script>

<style scoped lang="scss">
.input-group-text{
  cursor: pointer;
  user-select: none;
}
</style>
